/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionMetadataErrorDetails
 */
export interface PalAuthSubmissionMetadataErrorDetails {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetails
     */
    diagnosis_not_found?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetails
     */
    invalid_servicing_provider_name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetails
     */
    platform_message?: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadataErrorDetails interface.
 */
export function instanceOfPalAuthSubmissionMetadataErrorDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionMetadataErrorDetailsFromJSON(json: any): PalAuthSubmissionMetadataErrorDetails {
    return PalAuthSubmissionMetadataErrorDetailsFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataErrorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadataErrorDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'diagnosis_not_found': !exists(json, 'diagnosis_not_found') ? undefined : json['diagnosis_not_found'],
        'invalid_servicing_provider_name': !exists(json, 'invalid_servicing_provider_name') ? undefined : json['invalid_servicing_provider_name'],
        'platform_message': !exists(json, 'platform_message') ? undefined : json['platform_message'],
    };
}

export function PalAuthSubmissionMetadataErrorDetailsToJSON(value?: PalAuthSubmissionMetadataErrorDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'diagnosis_not_found': value.diagnosis_not_found,
        'invalid_servicing_provider_name': value.invalid_servicing_provider_name,
        'platform_message': value.platform_message,
    };
}

